import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppLayout } from "./layout";
import { AuthRoutes, MainRoutes } from "./routes";

export function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="main" />} />

        <Route path="main/*" element={<MainRoutes />} />
        <Route path="auth/*" element={<AuthRoutes />} />

        <Route path="*" element="App: Page Not Found" />
      </Route>
    </Routes>
  );
}
